import React, { useEffect, useState } from "react";
import {
  McModal,
  McButton,
} from "@maersk-global/mds-react-wrapper/components-core";
import { Typography, Tabs } from "@anchor/react-components/dist/lib/components";
import ReportComments from "./ReportComments";
import DetectionAndResponseSection from "./DetectionAndResponseSection";
import RegularTabContent from "./RegularTabContent";
import RootCauseIdentificationSection from "./RootCauseIdentificationSection";
import RootCausection from "./RootCausection";
import JiraSection from "./JiraSection";
import PTaskSection from "./PTaskSection";
import "./style.css";

function ReportSectionCommentModal({
  modalState,
  setCommentsToSend,
  comments,
  handleCommentModal,
  handelModalClosed
}) {
  const [currentActiveTab, setCurrentActiveTab] = useState(modalState.tabs[0]);
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleTabClick = (event) => {
    setCurrentActiveTab(event.selectedItemId);
    setCurrentTabIndex(
      event.updatedTabData.find((tab) => tab.id === event.selectedItemId).index
    );
  };

  const getTabData = () => {
    console.log(
      "HEADING AND INDEX ",
      modalState.sectionHeading,
      currentTabIndex
    );
    if (
      modalState.sectionHeading === "incident_summary" &&
      currentTabIndex === 3
    ) {
      return (
        <DetectionAndResponseSection
          data={modalState.tabsData[currentTabIndex]?.data}
          images={modalState.tabsData[currentTabIndex]?.images}
          requiredForModal={true}
        />
      );
    } else if (
      modalState.sectionHeading === "rootCause" &&
      currentTabIndex === 2
    ) {
      return (
        <RootCauseIdentificationSection
          data={modalState.tabsData[currentTabIndex]?.data}
          images={modalState.tabsData[currentTabIndex]?.images}
          requiredForModal={true}
        />
      );
    } else if (
      modalState.sectionHeading === "rootCause" &&
      currentTabIndex === 1
    ) {
      return (
        <RootCausection
          data={modalState.tabsData[currentTabIndex]?.data}
          images={modalState.tabsData[currentTabIndex]?.images}
          handleCommentModal={handleCommentModal}
          requiredForModal={true}
        />
      );
    } else if (
      modalState.sectionHeading === "preventiveCorrectiveMeasures" &&
      currentTabIndex === 0
    ) {
      return (
        <JiraSection
          data={modalState.tabsData[currentTabIndex]?.data}
          images={modalState.tabsData[currentTabIndex]?.images}
          requiredForModal={true}
        />
      );
    } else if (
      modalState.sectionHeading === "preventiveCorrectiveMeasures" &&
      currentTabIndex === 1
    ) {
      return (
        <PTaskSection
          data={modalState.tabsData[currentTabIndex]?.data}
          images={modalState.tabsData[currentTabIndex]?.images}
          requiredForModal={true}
        />
      );
    } else {
      return (
        <RegularTabContent
          data={modalState.tabsData[currentTabIndex]?.data}
          images={modalState.tabsData[currentTabIndex]?.images}
        />
      );
    }
  };

  return (
    <>
      <McModal
        backdropcloseactiondisabled={true}
        // heading="Heading"
        open={modalState.show}
        closed={() => console.log("closed")} //If needed, the event.detail gives you the action name which has closed the modal, for more details please look at the docs in the controls tab
        closing={() => console.log("closed")} //If needed, the event.detail gives you the action name which is closing the modal, for more details please look at the docs in the controls tab
        width={screenWidth >= 1600 ? "1600px" : `${screenWidth - 200}px`}
        height="700px"
      >
        <div
          style={{ display: "flex", padding: "20px", justifyContent: "center" }}
        >
          <div
            style={{
              width: "50%",
              padding: "10px",
            }}
          >
            {/* <Typography
              variant="h4"
              style={{ fontWeight: "bold" }}
              // paragraph={true}
            >
              {modalState.sectionHeading}
            </Typography> */}

            <Tabs
              items={
                modalState.tabs &&
                modalState.tabs.map((tab, i) => {
                  return {
                    active: currentTabIndex === i,
                    id: tab,
                    title: tab,
                    index: i,
                  };
                })
              }
              onClick={handleTabClick}
              type="default"
            />

            <div
              className="tab_content_container"
              style={{
                backgroundColor: "#E9F6FC",
                borderRadius: "10px",
                width: "100%",
                minHeight: "500px",
                maxHeight: "500px",
                overflowY: "scroll",
              }}
            >
              {getTabData()}
            </div>
          </div>
          <div
            style={{
              width: "1px",
              background: "#DBDBDB",
              height: "500px",
              marginTop: "40px",
            }}
          ></div>
          <div style={{ width: "50%", padding: "10px" }}>
            <Typography
              variant="h4"
              style={{ fontWeight: "bold" }}
              // paragraph={true}
            >
              Comments
            </Typography>
            <div
              style={{
                backgroundColor: "#E9F6FC",
                borderRadius: "10px",
                width: "100%",
                height: "500px",
              }}
            >
              <ReportComments
                comments={comments}
                setCommentsToSend={setCommentsToSend}
                currentSectionHeading={modalState.sectionHeading}
              />
            </div>
          </div>
        </div>
        <McButton
          focusstartanchor
          slot="primaryAction"
          appearance="primary"
          click={() => handelModalClosed()}
          dialogaction="ok"
        >
          OK
        </McButton>
        <McButton
          focusendanchor
          slot="secondaryAction"
          appearance="neutral"
          variant="outlined"
          click={() => console.log()}
          dialogaction="cancel"
        >
          Cancel
        </McButton>
      </McModal>
    </>
  );
}

export default ReportSectionCommentModal;
